var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBadgeIaabc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.01,
  fillRule: "evenodd",
  d: "M0 0v24h24V0z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#555",
  fillRule: "evenodd",
  d: "M12 15.411a.62.62 0 0 1 .365-.206l5.837-1.029c.323-.057.627.139.68.437l1.333 7.564a.55.55 0 0 1-.245.545.63.63 0 0 1-.63.044l-2.72-.495-2.387 1.395a.62.62 0 0 1-.606.174.55.55 0 0 1-.417-.428L12 16.55l-1.21 6.862a.55.55 0 0 1-.416.428.63.63 0 0 1-.606-.174L7.38 22.27l-2.72.496a.62.62 0 0 1-.63-.044.55.55 0 0 1-.244-.545l1.333-7.564c.053-.298.357-.494.68-.437l5.837 1.03c.149.026.276.102.364.205",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#555",
  stroke: "#3B3B3B",
  strokeWidth: 1.125,
  d: "M21.047 9.6c0 4.99-4.05 9.038-9.047 9.038S2.953 14.59 2.953 9.6C2.953 4.61 7.003.563 12 .563s9.047 4.046 9.047 9.037Z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 16,
  height: 17,
  x: 4,
  y: 1,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M12 17.569A7.969 7.969 0 1 0 12 1.63a7.969 7.969 0 0 0 0 15.938",
  clipRule: "evenodd"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M15.092 5.448c.505 0 .908.366.955.854L15.86 7.43a.19.19 0 0 1-.185.157H14.17l2.079 6.181a.188.188 0 0 1-.178.248h-1.387a.19.19 0 0 1-.176-.122L13.5 11.203l-1.563.723c-.03-.489-.847-1.05-1.624-1.051 0 0-.031.234 0 .234.74 0 1.402.364 1.406 1.079.001.109-.056.32-.088.435l-.006.023s.588-.13 1.15.338c.455.379.176.818.052.973a.16.16 0 0 1-.129.059H8.972a.19.19 0 0 1-.168-.104L7.72 11.747c-.771-.21-1.34-.899-1.345-1.717q0-.141.021-.275c.035-.155.108-.346.239.025.215.508.67.882 1.237 1.028l3.585-3.236-.25-2.107a.328.328 0 0 1 .514-.307l.411.29z",
  clipRule: "evenodd"
}))));
export default SvgBadgeIaabc;